import { UploadData } from '../../../../store/uploadStore';
import React from 'react';
import { isUploadCompleted } from '../helpers/completion';

interface Props {
  currentUploads: UploadData[];
}

export const GlobalUploadCount = ({ currentUploads }: Props) => {
  const completedCount = Object.values(currentUploads).reduce((acc, upload) => {
    return acc + Number(isUploadCompleted(upload));
  }, 0);
  const totalCount = Object.values(currentUploads).length;

  return (
    <span>
      {completedCount} / {totalCount}
    </span>
  );
};
